module.exports = "/assets/data/d32ba404a025998283b4b3ed87f6190b-LD6.data.json";